// eslint-disable-next-line import/prefer-default-export
export const extractHostname = (url) => {
  if (!url) {
    return undefined
  }

  const parts = url.split('//')
  const [noPort] = parts[parts.length - 1].split(':')
  const [noParam] = noPort.split('?')
  const [hostname] = noParam.split('/')

  return hostname
}
